/**
 * Gdy próbowano stworzyć rezerwację grupową, ale nie ma już wolnych pokojów
 */
export class GroupReservationNotAllowedException extends Error {
    constructor() {
        super('Group reservation is not allowed');
        this.name = "GroupReservationNotAllowedException";
    }
}